export default {
  // Navigation
  nav_home: 'হোম',
  nav_dashboard: 'ড্যাশবোর্ড',
  nav_orders: 'অর্ডারসমূহ',
  nav_wallet: 'ওয়ালেট',
  nav_analytics: 'অ্যানালিটিক্স',
  nav_referral: 'রেফারেল',
  nav_account: 'অ্যাকাউন্ট',
  nav_notifications: 'নোটিফিকেশন',
  nav_logout: 'লগআউট',
  nav_login: 'লগইন',
  nav_signup: 'সাইন আপ',
  nav_deposit_requests: 'ডিপোজিট অনুরোধ',
  nav_withdraw_requests: 'উত্তোলন অনুরোধ',
  nav_support_ticket: 'সাপোর্ট টিকিট',
  nav_system_logs: 'সিস্টেম লগ',
  nav_announcements: 'ঘোষণা',
  nav_activity_logs: 'অ্যাক্টিভিটি লগ',
  nav_settings: 'সেটিংস',
  nav_section_main: 'প্রধান',
  nav_user_active: 'এখন সক্রিয়',
  nav_more: 'আরও',
  nav_logout_confirm: 'আপনি কি নিশ্চিত যে আপনি লগআউট করতে চান?',
  nav_language: 'ভাষা',

  // Dashboard
  dashboard_welcome: 'আবার স্বাগতম',
  dashboard_total_earnings: 'মোট উপার্জন',
  dashboard_pending_orders: 'পেন্ডিং অর্ডার',
  dashboard_completed_orders: 'সম্পন্ন অর্ডার',
  dashboard_commission_rate: 'কমিশন হার',
  dashboard_quick_actions: 'কুইক অ্যাকশন',
  dashboard_recent_orders: 'সাম্প্রতিক অর্ডার',
  dashboard_recent_activity: 'সাম্প্রতিক কার্যকলাপ',
  dashboard_wallet_balance: 'ওয়ালেট ব্যালেন্স',
  dashboard_deposit: 'ডিপোজিট',
  dashboard_withdraw: 'উত্তোলন',
  dashboard_view_all: 'সব দেখুন',
  greeting_morning: 'শুভ সকাল',
  greeting_afternoon: 'শুভ দুপুর',
  greeting_evening: 'শুভ সন্ধ্যা',
  dashboard_greeting_desc: 'আপনার উপার্জন ট্র্যাক করুন, অর্ডার সম্পন্ন করুন এবং আপনার অ্যাকাউন্ট এক জায়গা থেকে ম্যানেজ করুন। আপনার সাফল্যের যাত্রা এখানেই চলুক!',

  // Dashboard Stats
  stats_available_balance: 'উপলব্ধ ব্যালেন্স',
  stats_total_withdrawn: 'মোট উত্তোলন',
  stats_total_deposit: 'মোট ডিপোজিট',
  stats_pending_orders: 'পেন্ডিং অর্ডার',
  stats_orders_suffix: ' টি অর্ডার',
  stats_task_earnings: 'টাস্ক উপার্জন',
  stats_lifetime_earning: 'লাইফটাইম উপার্জন',

  // Orders
  orders_title: 'আমার অর্ডার',
  orders_all: 'সব অর্ডার',
  orders_pending: 'পেন্ডিং',
  orders_completed: 'সম্পন্ন',
  orders_cancelled: 'বাতিল',
  orders_order_id: 'অর্ডার আইডি',
  orders_platform: 'প্ল্যাটফর্ম',
  orders_amount: 'পরিমাণ',
  orders_commission: 'কমিশন',
  orders_status: 'স্ট্যাটাস',
  orders_date: 'তারিখ',
  orders_actions: 'অ্যাকশন',
  orders_no_orders: 'কোনো অর্ডার পাওয়া যায়নি',

  // Wallet
  wallet_title: 'আমার ওয়ালেট',
  wallet_available_balance: 'উপলব্ধ ব্যালেন্স',
  wallet_pending_balance: 'পেন্ডিং ব্যালেন্স',
  wallet_total_withdrawn: 'মোট উত্তোলন',
  wallet_deposit_now: 'এখনই ডিপোজিট করুন',
  wallet_withdraw_now: 'এখনই উত্তোলন করুন',
  wallet_transaction_history: 'লেনদেনের ইতিহাস',
  wallet_deposit_history: 'ডিপোজিট ইতিহাস',
  wallet_withdrawal_history: 'উত্তোলন ইতিহাস',

  // Analytics
  analytics_title: 'অ্যানালিটিক্স',
  analytics_earnings_overview: 'উপার্জনের ওভারভিউ',
  analytics_platform_breakdown: 'প্ল্যাটফর্ম ব্রেকডাউন',
  analytics_performance_metrics: 'পারফরম্যান্স মেট্রিক্স',
  analytics_top_products: 'শীর্ষ পণ্য',
  analytics_this_month: 'এই মাস',
  analytics_last_month: 'গত মাস',
  analytics_total_revenue: 'মোট রাজস্ব',
  analytics_avg_order_value: 'গড় অর্ডার মান',

  // Referral
  referral_title: 'রেফারেল প্রোগ্রাম',
  referral_your_code: 'আপনার রেফারেল কোড',
  referral_copy_code: 'কোড কপি করুন',
  referral_share_link: 'লিঙ্ক শেয়ার করুন',
  referral_total_referrals: 'মোট রেফারেল',
  referral_active_referrals: 'সক্রিয় রেফারেল',
  referral_referral_earnings: 'রেফারেল উপার্জন',
  referral_invite_friends: 'বন্ধুদের আমন্ত্রণ জানান',

  // Account
  account_title: 'অ্যাকাউন্ট সেটিংস',
  account_profile: 'প্রোফাইল',
  account_security: 'নিরাপত্তা',
  account_notifications: 'নোটিফিকেশন',
  account_kyc: 'কেওয়াইসি যাচাইকরণ',
  account_phone: 'ফোন নম্বর',
  account_two_factor: 'টু-ফ্যাক্টর অথেন্টিকেশন',
  account_save_changes: 'পরিবর্তন সংরক্ষণ করুন',
  account_cancel: 'বাতিল',

  // Auth & Common
  auth_email: 'ইমেল',
  auth_password: 'পাসওয়ার্ড',
  auth_confirm_password: 'পাসওয়ার্ড নিশ্চিত করুন',
  auth_forgot_password: 'পাসওয়ার্ড ভুলে গেছেন?',
  auth_remember_me: 'আমাকে মনে রাখুন',
  auth_login_button: 'লগইন',
  auth_signup_button: 'সাইন আপ',
  auth_already_have_account: 'ইতিমধ্যেই অ্যাকাউন্ট আছে?',
  auth_dont_have_account: "অ্যাকাউন্ট নেই?",
  auth_reset_password: 'পাসওয়ার্ড রিসেট করুন',
  auth_verify_email: 'ইমেল যাচাই করুন',
  auth_live_platform: 'লাইভ প্ল্যাটফর্ম',
  auth_security_verification: 'নিরাপত্তা যাচাইকরণ',
  auth_captcha_refresh: 'রিফ্রেশ',
  auth_captcha_placeholder: 'ফলাফল',
  auth_captcha_error: 'ভুল যোগফল, অনুগ্রহ করে আবার চেষ্টা করুন',
  auth_branding_title: 'প্রমোশনকে পরিণত করুন',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'প্রকৃত আয়ে',
  auth_branding_desc: 'বিশ্বব্যাপী শীর্ষ ই-কমার্স ব্র্যান্ডগুলি থেকে দৈনিক কমিশন উপার্জনকারী হাজার হাজার প্রমোটারদের সাথে যোগ দিন।',
  auth_sign_in_to_account: 'আপনার {{system_name}} অ্যাকাউন্টে সাইন ইন করুন',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'পাসওয়ার্ড লিখুন',
  auth_signing_in: 'লগইন হচ্ছে...',
  auth_free_to_join: 'যোগদান বিনামূল্যে',
  auth_signup_branding_title: 'উপার্জন শুরু করুন',
  auth_signup_branding_highlight: 'প্রথম দিন থেকেই',
  auth_signup_branding_desc: 'কোনো অভিজ্ঞতার প্রয়োজন নেই। ২ মিনিটে সাইন আপ করুন এবং শীর্ষ ইকমার্স ব্র্যান্ডের জন্য টাস্ক সম্পন্ন করা শুরু করুন।',
  auth_how_it_works: 'এটি যেভাবে কাজ করে',
  auth_signup_desc: '{{system_name}}-এ যোগ দিন এবং আজই কমিশন উপার্জন শুরু করুন — এটি সম্পূর্ণ বিনামূল্যে!',
  auth_step_1: 'আপনার বিনামূল্যে অ্যাকাউন্ট তৈরি করুন',
  auth_step_2: 'টাস্ক খুঁজুন ও গ্রহণ করুন',
  auth_step_3: 'সম্পন্ন করুন ও কমিশন উপার্জন করুন',
  auth_signup_step_1_title: 'অ্যাকাউন্ট তৈরি করুন',
  auth_signup_step_1_desc: 'আপনার যাত্রা শুরু করুন',
  auth_signup_step_2_title: 'টাস্ক সম্পন্ন করুন',
  auth_signup_step_2_desc: 'দৈনিক কমিশন উপার্জন করুন',
  auth_signup_step_3_title: 'তহবিল উত্তোলন করুন',
  auth_signup_step_3_desc: 'দ্রুত এবং নিরাপদ পেমেন্ট',
  auth_benefit_1_title: 'নিরাপদ ও বিশ্বস্ত',
  auth_benefit_1_desc: 'আপনার উপার্জনের জন্য ব্যাংক-স্তরের নিরাপত্তা',
  auth_benefit_2_title: 'তাত্ক্ষণিক পেমেন্ট',
  auth_benefit_2_desc: '২৪ ঘণ্টার মধ্যে উপার্জন উত্তোলন করুন',
  auth_benefit_3_title: 'বৈশ্বিক কমিউনিটি',
  auth_benefit_3_desc: '{{count}}+ সক্রিয় প্রমোটারদের সাথে যোগ দিন',
  auth_benefit_4_title: '২৪/৭ সাপোর্ট',
  auth_benefit_4_desc: 'যখনই প্রয়োজন সাপোর্ট পান',
  auth_strength_weak: 'দুর্বল',
  auth_strength_fair: 'মোটামুটি',
  auth_strength_good: 'ভালো',
  auth_strength_strong: 'শক্তিশালী',
  auth_password_strength: 'পাসওয়ার্ডের শক্তি: {{strength}}',
  auth_social_proof: '{{count}}+ উপার্জনকারীদের সাথে যোগ দিন',
  auth_passwords_match: 'পাসওয়ার্ড মিলেছে',
  auth_creating_account: 'অ্যাকাউন্ট তৈরি হচ্ছে...',
  auth_phone_number: 'ফোন নম্বর',
  auth_phone_optional: '(ঐচ্ছিক)',
  auth_phone_placeholder: 'আপনার ফোন নম্বর',
  auth_full_name: 'পুরো নাম',
  auth_full_name_placeholder: 'আপনার নাম লিখুন',
  auth_password_min_chars: 'অন্তত ৮ অক্ষরের হতে হবে',
  auth_confirm_password_placeholder: 'পাসওয়ার্ডটি আবার লিখুন',
  auth_agree_to: 'আমি সম্মত হচ্ছি',
  auth_terms_of_service: 'পরিষেবার শর্তাবলী',
  auth_privacy_policy: 'গোপনীয়তা নীতি',
  auth_and: 'এবং',
  auth_create_free_account: 'বিনামূল্যে অ্যাকাউন্ট তৈরি করুন',

  common_loading: 'লোডিং...',
  common_save: 'সংরক্ষণ করুন',
  common_cancel: 'বাতিল',
  common_delete: 'মুছে ফেলুন',
  common_edit: 'সম্পাদনা',
  common_view: 'দেখুন',
  common_search: 'অনুসন্ধান',
  common_filter: 'ফিল্টার',
  common_export: 'এক্সপোর্ট',
  common_import: 'ইমপোর্ট',
  common_submit: 'জমা দিন',
  common_close: 'বন্ধ করুন',
  common_confirm: 'নিশ্চিত করুন',
  common_success: 'সফল',
  common_error: 'ত্রুটি',
  common_warning: 'সতর্কবাণী',
  common_announcement: 'ঘোষণা',

  val_full_name_required: 'পুরো নাম আবশ্যক',
  val_email_required: 'ইমেল আবশ্যক',
  val_password_required: 'পাসওয়ার্ড আবশ্যক',
  val_password_min: 'পাসওয়ার্ড অন্তত ৮ অক্ষরের হতে হবে',
  val_passwords_dont_match: 'পাসওয়ার্ড মেলেনি',
  val_agree_terms: 'আপনাকে শর্তাবলীতে সম্মত হতে হবে',
  val_conn_error: 'সংযোগ ত্রুটি। পুনরায় চেষ্টা করুন।',

  // Homepage
  home_hero_title: 'শীর্ষ ইকমার্স প্ল্যাটফর্ম থেকে কমিশন উপার্জন করুন',
  home_hero_subtitle: 'ওয়ালমার্ট, আলিবাবা এবং আলিএক্সপ্রেস থেকে দৈনিক কমিশন উপার্জনকারী হাজার হাজার ব্যবহারকারীদের সাথে যোগ দিন',
  home_get_started: 'এখনই শুরু করুন',
  home_learn_more: 'আরও জানুন',
  home_how_it_works: 'এটি কীভাবে কাজ করে',
  home_features: 'বৈশিষ্ট্যগুলি',
  home_why_choose_us: 'কেন আমাদের পছন্দ করবেন',
  home_features_title: 'শক্তিশালী বৈশিষ্ট্যগুলি',
  home_features_subtitle: 'অনলাইনে উপার্জন শুরু করার জন্য আপনার যা কিছু প্রয়োজন। আপনার সাফল্যের কথা মাথায় রেখে তৈরি।',
  home_commission_tiers: 'কমিশন টিয়ার',
  home_testimonials: 'আমাদের ব্যবহারার্থীরা কী বলেন',
  home_faq: 'সাধারণ প্রশ্নাবলী',
  home_cta_title: 'উপার্জন শুরু করতে প্রস্তুত?',
  home_cta_subtitle: 'আজই আমাদের কমিউনিটিতে যোগ দিন এবং কমিশন উপার্জন শুরু করুন',
  home_trusted_partner: 'বিশ্বস্ত পার্টনার প্ল্যাটফর্ম',
  home_secure_platform: 'নিরাপদ প্ল্যাটফর্ম',
  home_instant_payouts: 'তাত্ক্ষণিক পেমেন্ট',
  home_active_users: 'সক্রিয় ব্যবহারকারী',
  home_paid_out: 'পেমেন্ট করা হয়েছে',
  home_total_paid_out: 'মোট পেমেন্ট করা হয়েছে',
  home_user_rating: 'ব্যবহারকারী রেটিং',
  home_countries: 'দেশসমূহ',
  home_commission_badge: 'উপার্জন সম্ভাবনা',
  home_commission_title: 'কমিশন হার',
  home_commission_desc: 'উচ্চতর ব্যালেন্সের সাথে উন্নত কমিশন হার আনলক হয়। প্রতিটি সেশনে ঠিক ২৫টি অর্ডার থাকে — সর্বোচ্চ উপার্জনের জন্য প্রতিদিন ৪টি সেশন পর্যন্ত সম্পন্ন করুন।',
  home_tier_popular: 'সবচেয়ে জনপ্রিয়',
  home_tier_commission_per_order: 'অর্ডার প্রতি কমিশন',
  home_tier_earn_examples: 'উপার্জনের উদাহরণ:',
  home_tier_order: 'অর্ডার',
  home_tier_batch_earn: '২৫টি অর্ডারে উপার্জন:',
  home_tier_daily_potential: 'দৈনিক সম্ভাবনা (৪ ব্যাচ × ২৫ অর্ডার)',
  home_tier_max_daily: 'প্রতিদিন ১০০টি অর্ডার পর্যন্ত',
  home_tier_benefit_1: 'প্রতি ব্যাচে ২৫টি অর্ডার',
  home_tier_benefit_2: 'প্রতিদিন সর্বোচ্চ ৪টি ব্যাচ',
  home_tier_benefit_3: 'তাত্ক্ষণিক কমিশন ক্রেডিট',
  home_tier_above: 'এর উপরে',
  home_tier_no_tiers: 'কোনো কমিশন টিয়ার পাওয়া যায়নি।',

  // Comparison Section
  home_compare_badge: 'পার্থক্য',
  home_compare_title: 'কেন আমরা সেরা',
  home_compare_subtitle: 'ঐতিহ্যবাহী পার্ট-টাইম চাকরীর সাথে আমাদের প্ল্যাটফর্ম তুলনা করুন এবং দেখুন কেন হাজার হাজার মানুষ আমাদের বেছে নেয়।',
  home_compare_feature: 'বৈশিষ্ট্য',
  home_compare_traditional: 'ঐতিহ্যবাহী চাকরি',
  home_compare_our_platform: 'আমাদের প্ল্যাটফর্ম',
  home_compare_f1: 'নমনীয়তা',
  home_compare_f1_trad: 'নির্ধারিত সময়সূচী',
  home_compare_f1_our: 'যেকোনো সময়, যেকোনো জায়গায় কাজ করুন',
  home_compare_f2: 'পেমেন্ট',
  home_compare_f2_trad: 'মাসিক বা দ্বৈ-সাপ্তাহিক',
  home_compare_f2_our: 'তাত্ক্ষণিক / একই দিনে',
  home_compare_f3: 'প্রয়োজনীয়তা',
  home_compare_f3_trad: 'অভিজ্ঞতা/সিভি/ইন্টারভিউ',
  home_compare_f3_our: 'নেই - শুধু একটি স্মার্টফোন প্রয়োজন',
  home_compare_f4: 'বৃদ্ধি',
  home_compare_f4_trad: 'নির্ধারিত বার্ষিক বৃদ্ধি',
  home_compare_f4_our: 'টিয়ার-ভিত্তিক সীমাহীন বৃদ্ধি',

  // Testimonials
  home_testi_badge: 'সাফল্যের কাহিনী',
  home_testi_title: 'হাজার হাজার মানুষের বিশ্বস্ত',
  home_testi_subtitle: 'আমাদের প্রমোটারদের বৈশ্বিক কমিউনিটির কাছ থেকে শুনুন যারা তাদের আয় পরিবর্তন করেছেন।',
  home_testi_no_stories: 'এখনও কোনো সাফল্যের কাহিনী নেই।',
  home_testi_total_earned: 'মোট উপার্জন',
  home_testi_time_period: 'সময়কাল',
  home_testi_verified: 'যাচাইকৃত ব্যবহারকারী',
  home_testi_avg_rating: 'গড় রেটিং',
  home_testi_satisfaction_rate: 'সন্তুষ্টির হার',
  home_testi_support_available: 'সাপোর্ট উপলব্ধ',

  // FAQ
  home_faq_badge: 'সাপোর্ট',
  home_faq_title: 'সাধারণ প্রশ্নাবলী',
  home_faq_subtitle: 'শুরু করা এবং উপার্জন সম্পর্কে আপনার যা কিছু জানা দরকার।',
  home_faq_no_data: 'কোনো প্রশ্ন পাওয়া যায়নি।',

  // Trust Bar
  home_trust_badge: 'বৈশ্বিক বিশ্বাস',
  home_trust_title: 'শীর্ষ ব্র্যান্ডের বিশ্বস্ত',
  home_trust_desc: 'আমরা যাচাইকৃত প্রমোশন পরিষেবা প্রদানের জন্য বিশ্বের বৃহত্তম ই-কমার্স প্ল্যাটফর্মগুলির সাথে পার্টনারশিপ করি।',

  // Feature Section
  feature_1_title: 'তাত্ক্ষণিক পেমেন্ট',
  feature_1_desc: 'অর্ডার সম্পন্ন করার পর তাত্ক্ষণিকভাবে আপনার উপার্জন জমা হবে। কোনো বিলম্ব ছাড়াই যেকোনো সময় উত্তোলন করুন।',
  feature_1_detail_1: 'রিয়েল-টাইম কমিশন ক্রেডিট',
  feature_1_detail_2: 'একাধিক উত্তোলনের বিকল্প',
  feature_1_detail_3: 'কোনো সর্বনিম্ন সীমা নেই',
  feature_2_title: 'নিরাপদ প্ল্যাটফর্ম',
  feature_2_desc: 'ব্যাংক-স্তরের এনক্রিপশন আপনার ডেটা এবং উপার্জনকে রক্ষা করে। বিশ্বজুড়ে হাজার হাজার ব্যবহারকারীর বিশ্বস্ত।',
  feature_2_detail_1: 'SSL এনক্রিপশন সক্রিয়',
  feature_2_detail_2: 'টু-ফ্যাক্টর অথেন্টিকেশন',
  feature_2_detail_3: 'নিয়মিত নিরাপত্তা অডিট',
  feature_2_detail_4: 'ডেটা গোপনীয়তা নিশ্চিত',
  feature_3_title: 'নমনীয় সময়',
  feature_3_desc: 'যখন খুশি কাজ করুন, আপনি যেখানেই থাকুন না কেন। কোনো নির্ধারিত সময়সূচী ছাড়াই আপনার নিজের গতিতে অর্ডার সম্পন্ন করুন।',
  feature_3_detail_1: 'কোনো নির্ধারিত কর্মঘণ্টা নেই',
  feature_3_detail_2: 'যেকোনো জায়গা থেকে কাজ করুন',
  feature_3_detail_3: 'আপনার নিজের গতি বেছে নিন',
  feature_3_detail_4: 'সপ্তাহের শেষেও কাজ করার সুবিধা',
  feature_4_title: 'প্রগতিশীল উপার্জন',
  feature_4_desc: 'অধিক অর্ডার সম্পন্ন করার সাথে সাথে উচ্চতর কমিশন হার আনলক করুন। প্রতিটি টিয়ার আপগ্রেডের সাথে আপনার আয় বৃদ্ধি করুন।',
  feature_4_detail_1: 'টিয়ার-ভিত্তিক কমিশন হার',
  feature_4_detail_2: 'স্বয়ংক্রিয় টিয়ার আপগ্রেড',
  feature_4_detail_3: 'পারফরম্যান্স পুরস্কার',
  feature_5_title: 'বৈশ্বিক প্ল্যাটফর্ম',
  feature_5_desc: 'বিশ্বের যেকোনো প্রান্ত থেকে আন্তর্জাতিক ব্র্যান্ডের সাথে কাজ করুন। মাল্টি-কারেন্সি সাপোর্ট অন্তর্ভুক্ত।',
  feature_5_detail_1: 'বিশ্বব্যাপী উপলব্ধ',
  feature_5_detail_2: 'মাল্টি-কারেন্সি সাপোর্ট',
  feature_5_detail_3: 'স্থানীয় পেমেন্ট পদ্ধতি',
  feature_6_title: '২৪/৭ সাপোর্ট',
  feature_6_desc: 'আমাদের ডেডিকেটেড সাপোর্ট টিম সবসময় সাহায্য করতে প্রস্তুত। লাইভ চ্যাট, ইমেল বা ফোনের মাধ্যমে সহায়তা পান।',
  feature_6_detail_1: 'লাইভ চ্যাট উপলব্ধ',
  feature_6_detail_2: '২৪/৭ ইমেল সাপোর্ট',
  feature_6_detail_3: 'ফোন সহায়তা',
  feature_6_detail_4: 'বিস্তারিত প্রশ্নোত্তর',
  feature_7_title: 'রেফারেল প্রোগ্রাম',
  feature_7_desc: 'বন্ধুদের আমন্ত্রণ জানিয়ে অতিরিক্ত আয় করুন। আপনার রেফারেলদের উপার্জন থেকে লাইফটাইম কমিশন পান।',
  feature_7_detail_1: 'লাইফটাইম রেফারেল আয়',
  feature_7_detail_2: 'আনলিমিটেড রেফারেল',
  feature_7_detail_3: 'সহজ শেয়ারিং টুলস',
  feature_7_detail_4: 'বোনাস ইনসেনটিভ',
  feature_8_title: 'মাল্টি-কারেন্সি',
  feature_8_desc: 'প্রধান মুদ্রা এবং পেমেন্ট পদ্ধতির জন্য সাপোর্ট। আপনার জন্য যা সবচেয়ে ভালো কাজ করে তা বেছে নিন।',
  feature_8_detail_1: 'USD, EUR, GBP সাপোর্ট',
  feature_8_detail_2: 'ব্যাংক ট্রান্সফার উপলব্ধ',
  feature_8_detail_3: 'ই-ওয়ালেট ইন্টিগ্রেশন',
  feature_8_detail_4: 'ক্রিপ্টো অপশন শীঘ্রই আসছে',
  feature_9_title: 'তাত্ক্ষণিক নোটিফিকেশন',
  feature_9_desc: 'নতুন অর্ডার, উপার্জন এবং অ্যাকাউন্ট কার্যকলাপের জন্য রিয়েল-টাইম অ্যালার্টের সাথে আপডেট থাকুন।',
  feature_9_detail_1: 'পুশ নোটিফিকেশন',
  feature_9_detail_2: 'ইমেল অ্যালার্ট',
  feature_9_detail_3: 'এসএমএস আপডেট',
  feature_9_detail_4: 'ইন-অ্যাপ মেসেজ',

  // Home Page Additional Sections
  home_how_it_works_badge: 'সহজ প্রক্রিয়া',
  home_how_it_works_title: 'এটি কীভাবে কাজ করে',
  home_how_it_works_subtitle: '৪টি সহজ ধাপে উপার্জন শুরু করুন। কোনো অভিজ্ঞতার প্রয়োজন নেই, শুধু প্রক্রিয়াটি অনুসরণ করুন এবং আপনার উপার্জন বাড়তে দেখুন।',
  home_cta_ready_title: 'আপনার যাত্রা শুরু করতে প্রস্তুত?',
  home_cta_ready_desc: 'ইতিমধ্যেই দৈনিক উপার্জন করছেন এমন হাজার হাজার ব্যবহারকারীদের সাথে যোগ দিন। আপনার প্রথম কমিশন মাত্র কয়েক মিনিটের দূরত্বে!',
  home_cta_avg_time: 'প্রথম উপার্জনের গড় সময়:',
  home_cta_15_mins: '১৫ মিনিট',
  home_cta_new_users: 'আজ নতুন ব্যবহারকারী:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'এই মাসে সীমিত আসন উপলব্ধ',
  home_cta_main_title: 'অর্থ উপার্জন শুরু করুন',
  home_cta_today: 'আজই!',
  home_cta_main_desc: 'ইতিমধ্যেই দৈনিক কমিশন উপার্জন করছেন এমন হাজার হাজার ব্যবহারকারীদের সাথে যোগ দিন। কোনো অভিজ্ঞতার প্রয়োজন নেই, নমনীয় সময়, তাত্ক্ষণিক পেমেন্ট। আপনার আর্থিক স্বাধীনতা এখান থেকেই শুরু হয়।',
  home_cta_spots_remaining: 'আসন বাকি আছে',
  home_cta_new_users_today: 'আজ নতুন ব্যবহারকারী',
  home_cta_create_account: 'বিনামূল্যে অ্যাকাউন্ট তৈরি করুন',
  home_cta_sign_in: 'সাইন ইন করুন',
  home_cta_secure: '১০০% নিরাপদ',
  home_cta_payouts: '২৪-৪৮ ঘণ্টার মধ্যে পেমেন্ট',
  home_cta_rating: '৪.৯/৫ রেটিং',
  home_cta_active_users: 'সক্রিয় ব্যবহারকারী',
  home_cta_total_paid: 'মোট পেমেন্ট',
  home_cta_orders_done: 'সম্পন্ন কাজ',
  home_cta_satisfaction: 'সন্তুষ্টি',
  home_cta_guarantee_title: 'মানি-ব্যাক গ্যারান্টি',
  home_cta_guarantee_desc: 'সন্তুষ্ট নন? ৭ দিনের মধ্যে আপনার ডিপোজিট ফেরত পান',

  // Footer Branding & Extras
  footer_brand_desc: 'বিশ্বের শীর্ষস্থানীয় ই-কমার্স প্রমোশন প্ল্যাটফর্ম। আমাদের প্রমোটারদের বৈশ্বিক নেটওয়ার্কে যোগ দিন এবং আজই শীর্ষ ব্র্যান্ডগুলি থেকে কমিশন উপার্জন শুরু করুন।',
  footer_ssl_secure: 'SSL সুরক্ষিত',
  footer_aes_256: 'AES-256 এনক্রিপশন',
  footer_cookie_policy: 'কুকি নীতি',
  footer_disclaimer: 'দাবিত্যাগ',
  footer_all_rights: 'সর্বস্বত্ব সংরক্ষিত।',

  // Announcements
  announcement_withdrawal_delay_title: 'উত্তোলন প্রক্রিয়াকরণে বিলম্ব',
  announcement_withdrawal_delay_summary: 'অত্যধিক চাপের কারণে উত্তোলন প্রক্রিয়াকরণে ৭২ ঘণ্টা পর্যন্ত সময় লাগতে পারে। অনুগ্রহ করে ধৈর্য ধরুন।',
  announcement_date_june_14: '১৪ জুন, ২০২৫',

  // Wallet Page & Detailed Requests
  wallet_page_desc: 'আপনার উপার্জন এবং লেনদেন পরিচালনা করুন',
  wallet_err_fetch: 'ওয়ালেট ডাটা আনতে ব্যর্থ হয়েছে',
  wallet_err_fetch_summary: 'অ্যাকাউন্টের সারাংশ আনার সময় একটি ত্রুটি ঘটেছে',
  wallet_unlock_withdrawal: 'উত্তোলন আনলক করতে সমস্ত ২৫টি অর্ডার সম্পন্ন করুন',
  wallet_withdrawals_badge: 'উত্তোলন',
  wallet_pending_badge: 'পেন্ডিং',
  wallet_total_earnings_badge: 'মোট উপার্জন',
  wallet_err_fetch_deposits: 'ডিপোজিট আনতে ব্যর্থ হয়েছে',
  wallet_cancel_deposit_confirm: 'আপনি কি নিশ্চিত?',
  wallet_cancel_deposit_text: 'আপনি কি এই ডিপোজিট অনুরোধটি বাতিল করতে চান?',
  wallet_cancel_deposit_yes: 'হ্যাঁ, বাতিল করুন!',
  wallet_cancel_deposit_success: 'ডিপোজিট অনুরোধ সফলভাবে মুছে ফেলা হয়েছে।',
  wallet_cancel_deposit_err: 'ডিপোজিট মুছতে ব্যর্থ হয়েছে',
  wallet_cancel_deposit_err_summary: 'ডিপোজিট মোছার সময় একটি ত্রুটি ঘটেছে',
  wallet_no_deposits_title: 'এখনও কোনো ডিপোজিট নেই',
  wallet_no_deposits_desc: "আপনি কোনো ডিপোজিট করেননি। আপনার ওয়ালেটে তহবিল যোগ করতে উপরের ডিপোজিট বাটনে ক্লিক করুন!",
  wallet_cancel_tooltip: 'ডিপোজিট বাতিল করুন',
  wallet_status_completed: 'সম্পন্ন',
  wallet_status_rejected: 'প্রত্যাখ্যাত',
  wallet_status_pending: 'পেন্ডিং',
  wallet_table_date: 'তারিখ',
  wallet_table_trx: 'লেনদেন আইডি',
  wallet_table_desc: 'বিবরণ',
  wallet_table_amount: 'পরিমাণ',
  wallet_table_status: 'স্ট্যাটাস',
  wallet_table_actions: 'অ্যাকশন',
  wallet_table_id: 'আইডি',
  wallet_load_more: 'আরও লোড করুন',
  wallet_loading: 'লোডিং...',
  wallet_err_fetch_transactions: 'লেনদেন আনতে ব্যর্থ হয়েছে',
  wallet_filter_all: 'সব',
  wallet_filter_deposits: 'ডিপোজিট',
  wallet_filter_withdrawals: 'উত্তোলন',
  wallet_filter_commissions: 'কমিশন',
  wallet_no_transactions_title: 'এখনও কোনো লেনদেন নেই',
  wallet_no_transactions_desc: "আপনার কোনো {{filter}} লেনদেন নেই। কমিশন উপার্জন শুরু করুন বা একটি ডিপোজিট করুন!",
  wallet_deposit_desc: "উপলব্ধ পেমেন্ট পদ্ধতি ব্যবহার করে আপনার ওয়ালেটে টাকা যোগ করুন।",
  wallet_no_deposits: "কোনো জমা পাওয়া যায়নি।",
  wallet_withdraw_history: "উত্তোলনের ইতিহাস",
  wallet_withdraw_desc: "আপনার ওয়ালেট থেকে টাকা উত্তোলন করুন।",
  wallet_no_withdrawals: "কোনো উত্তোলন পাওয়া যায়নি।",
  wallet_no_withdrawals_desc: "আপনি এখনো কোনো উত্তোলন করেননি।",
  // Deposit & Withdraw Requests Pages
  deposit_requests_title: 'ডিপোজিট অনুরোধ',
  deposit_requests_desc: 'আপনার ডিপোজিট অনুরোধগুলো দেখুন এবং পরিচালনা করুন',
  withdraw_requests_title: 'উত্তোলন অনুরোধ',
  withdraw_requests_desc: 'আপনার উত্তোলন অনুরোধগুলো দেখুন এবং পরিচালনা করুন',

  // Orders Page (Detailed)
  orders_step_1: 'পণ্যের বিবরণ পর্যালোচনা করা হচ্ছে',
  orders_step_2: 'অর্ডার তথ্য যাচাই করা হচ্ছে',
  orders_step_3: 'প্ল্যাটফর্মের সাথে সংযুক্ত করা হচ্ছে',
  orders_step_4: 'প্রমোশন জমা দেওয়া হচ্ছে',
  orders_step_5: 'চূড়ান্ত ও নিশ্চিত করা হচ্ছে',
  orders_no_active_tasks: 'কোনো সক্রিয় টাস্ক উপলব্ধ নেই।',
  orders_err_fetch_task: 'সক্রিয় টাস্ক আনতে ব্যর্থ হয়েছে',
  orders_err_oops: 'উফ...',
  orders_err_process: 'অর্ডার প্রসেস করতে ব্যর্থ হয়েছে',
  orders_err_title: 'ত্রুটি',
  orders_err_occured: 'অর্ডার প্রসেস করার সময় একটি ত্রুটি ঘটেছে।',
  orders_submitting_task: 'টাস্ক জমা দেওয়া হচ্ছে...',
  orders_submitting_desc: 'অনুগ্রহ করে অপেক্ষা করুন যখন আমরা আপনার সম্পন্ন হওয়া প্রসেস করছি এবং তহবিল স্থানান্তর করছি।',
  orders_completed_title: 'টাস্ক সম্পন্ন!',
  orders_completed_desc: 'আপনার ওয়ালেটে কমিশন যোগ করা হয়েছে।',
  orders_submit_failed: 'জমা দিতে ব্যর্থ',
  orders_submit_err: 'টাস্ক জমা দিতে ব্যর্থ হয়েছে',
  orders_submit_err_occured: 'টাস্ক জমা দেওয়ার সময় একটি ত্রুটি ঘটেছে।',
  orders_page_desc: 'আপনার ওয়ালেটে সরাসরি কমিশন উপার্জন করতে অর্ডার সম্পন্ন করুন।',
  orders_loading_data: 'টাস্ক ডাটা লোড হচ্ছে...',
  orders_no_pending: 'কোনো পেন্ডিং টাস্ক নেই',
  orders_progress: 'টাস্ক অগ্রগতি',
  orders_suffix: 'অর্ডার',
  orders_total_earned: 'মোট উপার্জিত কমিশন:',
  orders_toast_completed: 'অর্ডার সম্পন্ন!',
  orders_toast_desc: '{{amount}} সম্ভাব্য কমিশন গণনা করা হয়েছে।',
  orders_congrats: "অভিনন্দন! আপনি সমস্ত {{required}}টি অর্ডার সম্পন্ন করেছেন এবং এই টাস্কের জন্য মোট {{total}} কমিশন উপার্জন করেছেন।",
  orders_btn_claim: 'আপনার কমিশন দাবি করুন',
  orders_btn_submitting: 'জমা হচ্ছে...',
  orders_prefix: 'অর্ডার #',
  orders_release_desc: 'আপনার কমিশন সুরক্ষিত করতে অনুগ্রহ করে এই অর্ডারটি রিলিজ করুন।',
  orders_expected_earn: 'মোট সম্ভাব্য আয়',
  orders_processing: 'প্রসেসিং হচ্ছে...',
  orders_btn_release: 'অর্ডার রিলিজ করুন',
  orders_how_it_works: 'এটি কীভাবে কাজ করে',
  orders_grab_title: 'অর্ডার ধরুন',
  orders_grab_desc: 'প্রসেসিং শুরু করতে "অর্ডার রিলিজ করুন" ক্লিক করুন। অর্ডারগুলো ধারাবাহিকভাবে বরাদ্দ করা হয় এবং এড়ানো যায না।',
  orders_promote_title: 'পণ্য প্রমোশন',
  orders_promote_desc: 'আমাদের সিস্টেম স্বয়ংক্রিয়ভাবে একাধিক প্ল্যাটফর্মে পণ্যটি প্রমোট করে এবং সার্চ ভিজিবিলিটি অপ্টিমাইজ করে।',
  orders_earn_title: 'কমিশন উপার্জন',
  orders_earn_desc: 'প্রতিটি অর্ডার সম্পন্ন হওয়ার সাথে সাথে কমিশন তাত্ক্ষণিকভাবে গণনা করা হয়।',
  orders_claim_title: 'দাবি ও উত্তোলন',
  orders_claim_desc: 'আপনার উপার্জনকে স্থায়ীভাবে আপনার ওয়ালেটে স্থানান্তর করতে আপনার সম্পূর্ণ টাস্কটি জমা দিন।',
  orders_rules_title: 'অর্ডার নিয়ম',
  orders_rule_1: 'আপনাকে আপনার নির্ধারিত টাস্কের সমস্ত প্রয়োজনীয় অর্ডার সম্পন্ন করতে হবে',
  orders_rule_2: 'আপনার টাস্ক সম্পন্ন হলে, তহবিল স্থানান্তর করতে "আপনার কমিশন দাবি করুন" ক্লিক করুন',
  orders_rule_3: 'অর্ডারগুলো অবশ্যই ধারাবাহিকভাবে সম্পন্ন করতে হবে — কোনো স্কিপ করা যাবে না',
  orders_rule_4: 'অর্ডার প্রসেসিংয়ের সময় পাতাটি বন্ধ করবেন না',
  orders_rule_5: 'প্রতারণামূলক কার্যকলাপের ফলে অ্যাকাউন্ট স্থগিত করা হবে',
  orders_processing_title: 'আপনার অর্ডার প্রসেসিং হচ্ছে',
  orders_processing_stay: 'এই উইন্ডোটি বন্ধ করবেন না',
  orders_platform_amazon: 'Amazon',
  orders_platform_ebay: 'eBay',
  orders_platform_aliexpress: 'AliExpress',
  orders_platform_default: 'প্ল্যাটফর্ম',

  // Analytics Page (Detailed)
  analytics_7_days: '৭ দিন',
  analytics_30_days: '৩০ দিন',
  analytics_90_days: '৯০ দিন',
  analytics_all_time: 'সর্বকালের',
  analytics_perf_title: 'পারফরম্যান্স অ্যানালিটিক্স',
  analytics_perf_desc: 'সমস্ত প্ল্যাটফর্মে আপনার উপার্জন এবং অর্ডারের পারফরম্যান্স ট্র্যাক করুন।',
  analytics_total_earnings_stat: 'মোট উপার্জন',
  analytics_orders_completed_stat: 'অর্ডার সম্পন্ন',
  analytics_avg_commission_stat: 'গড় কমিশন',
  analytics_conversion_rate_stat: 'কনভার্সন রেট',
  analytics_timeline_title: 'সময়ের সাথে পারফরম্যান্স',
  analytics_timeline_desc: 'আপনার কার্যকলাপের চিত্রায়ন',
  analytics_earnings_tab: 'উপার্জন',
  analytics_orders_tab: 'অর্ডার',
  analytics_distribution: 'প্ল্যাটফর্ম ডিস্ট্রিবিউশন',
  analytics_strongest_on: 'আপনার পারফরম্যান্স {{platform}}-এ সবচেয়ে শক্তিশালী।',
  analytics_top_performing: 'শীর্ষ পারফর্মিং পণ্য',
  analytics_top_suffix: 'শীর্ষ {{count}}',
  analytics_product_info: 'পণ্যের তথ্য',
  analytics_platform: 'প্ল্যাটফর্ম',
  analytics_rate: 'হার',
  analytics_earned: 'উপার্জিত',
  analytics_no_data: 'এই সময়ের জন্য কোনো পণ্যের তথ্য উপলব্ধ নেই।',

  // Notifications Page
  notifications_title: 'ঘোষণা ও সংবাদ',
  notifications_desc: 'সর্বশেষ প্ল্যাটফর্ম আপডেট এবং সংবাদের সাথে আপ টু ডেট থাকুন',
  notifications_unread: 'টি অপঠিত ঘোষণা',
  notifications_unread_plural: 'টি অপঠিত ঘোষণা',
  notifications_caught_up: 'সবই পড়া হয়ে গেছে!',
  notifications_no_announcements: 'এই বিভাগে কোনো ঘোষণা নেই',
  notifications_pinned: 'পিন করা',
  notifications_new: 'নতুন',
  notifications_published: 'প্রকাশিত:',
  notifications_read: 'পড়া হয়েছে',
  notifications_tab_all: 'সব',
  notifications_tab_update: 'আপডেট',
  notifications_tab_maintenance: 'রক্ষণাবেক্ষণ',
  notifications_tab_promotion: 'প্রমোশন',
  notifications_tab_news: 'সংবাদ',
  notifications_tab_alert: 'সতর্কতা',

  // Activity Logs
  activity_title: 'ব্যক্তিগত অ্যাক্টিভিটি লগ',
  activity_desc: 'নিরাপত্তা অডিটের জন্য অ্যাকাউন্ট অ্যাকশন',
  activity_action: 'অ্যাকশন',
  activity_details: 'বিস্তারিত',
  activity_ip: 'আইপি ঠিকানা',
  activity_date: 'তারিখ',
  activity_no_logs: 'কোনো অ্যাক্টিভিটি লগ পাওয়া যায়নি',
  activity_prev: 'আগের',
  activity_next: 'পরের',
  activity_page_of: 'পৃষ্ঠা {{current}} / {{total}}',

  // Account & Profile
  account_profile_title: 'অ্যাকাউন্ট প্রোফাইল',
  account_profile_desc: 'আপনার ব্যক্তিগত তথ্য এবং অবতার পরিচালনা করুন',
  account_info_title: 'প্রোফাইল তথ্য',
  account_edit_btn: 'সম্পাদনা',
  account_avatar_alt: 'প্রোফাইল অবতার',
  account_avatar_hint: 'JPG, PNG বা GIF • সর্বোচ্চ ২ মেগাবাইট',
  account_avatar_invalid: 'অনুগ্রহ করে একটি সঠিক ইমেজ ফাইল আপলোড করুন (JPG, PNG বা GIF)',
  account_avatar_size: 'ফাইল সাইজ ২ মেগাবাইটের কম হতে হবে',
  account_avatar_err: 'ছবি আপলোড করতে ব্যর্থ হয়েছে',
  account_avatar_conn_err: 'আপলোড করার সময় সংযোগ ত্রুটি',
  account_full_name: 'পুরো নাম',
  account_email_addr: 'ইমেল ঠিকানা',
  account_phone_num: 'ফোন নম্বর',
  account_not_set: 'সেট করা নেই',
  account_save_btn: 'পরিবর্তন সংরক্ষণ করুন',
  account_updating: 'আপডেট হচ্ছে...',
  account_update_success: 'প্রোফাইল সফলভাবে আপডেট করা হয়েছে!',
  account_update_err: 'প্রোফাইল আপডেট করতে ব্যর্থ হয়েছে',
  account_auth_err: 'অথেন্টিকেটেড নয়',
  account_fetch_err: 'প্রোফাইল আনতে ব্যর্থ হয়েছে',
  account_conn_err: 'সংযোগ ত্রুটি',

  // KYC Section
  kyc_title: 'কেওয়াইসি যাচাইকরণ',
  kyc_status_unverified: 'অযাচাইকৃত',
  kyc_status_pending: 'পর্যালোচনার অপেক্ষায়',
  kyc_status_approved: 'অনুমোদিত',
  kyc_status_rejected: 'প্রত্যাখ্যাত',
  kyc_loading: 'পরিচয় স্থিতি লোড হচ্ছে...',
  kyc_complete_title: 'যাচাইকরণ সম্পন্ন',
  kyc_complete_desc: 'আপনার পরিচয় যাচাই করা হয়েছে। আপনি এখন সমস্ত প্ল্যাটফর্ম ফিচারে পূর্ণ অ্যাক্সেস পাবেন।',
  kyc_submitted_title: 'নথিপত্র জমা দেওয়া হয়েছে',
  kyc_submitted_desc: 'আপনার নথিপত্র পর্যালোচনা করা হচ্ছে। এটি সাধারণত ১-৩ কার্যদিবস সময় নেয়।',
  kyc_verified_details: 'যাচাইকৃত বিবরণ',
  kyc_unlock_desc: 'সম্পূর্ণ উত্তোলন অ্যাক্সেস এবং উচ্চতর সীমা আনলক করতে পরিচয় যাচাইকরণ সম্পন্ন করুন।',
  kyc_dob: 'জন্ম তারিখ',
  kyc_country: 'দেশ',
  kyc_id_number: 'আইডি নম্বর',
  kyc_address: 'ঠিকানা',
  kyc_address_placeholder: 'রাস্তার ঠিকানা, শহর, পোস্টকোড',
  kyc_select_id: 'নথির ধরন নির্বাচন করুন',
  kyc_national_id: 'জাতীয় পরিচয়পত্র',
  kyc_passport: 'পাসপোর্ট',
  kyc_driving_license: "ড্রাইভিং লাইসেন্স",
  kyc_id_doc: 'পরিচয় নথি',
  kyc_selfie: 'সেলফি যাচাইকরণ',
  kyc_guidelines_title: 'আপলোড নির্দেশিকা',
  kyc_guidelines_1: 'নথিপত্র অবশ্যই বৈধ হতে হবে এবং মেয়াদ উত্তীর্ণ হওয়া যাবে না',
  kyc_guidelines_2: 'নথির চারটি কোণই দৃশ্যমান হতে হবে',
  kyc_guidelines_3: 'ছবিগুলো পরিষ্কার, পর্যাপ্ত আলোযুক্ত এবং ফোকাসে থাকতে হবে',
  kyc_guidelines_4: 'গৃহীত ফরম্যাট: JPG, PNG, PDF (সর্বোচ্চ ৫ মেগাবাইট)',
  kyc_submit_btn: 'যাচাইয়ের জন্য জমা দিন',
  kyc_submitting: 'জমা হচ্ছে...',
  kyc_err_submit: 'KYC জমা দিতে ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
  kyc_err_conn: 'সংযোগ ত্রুটি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  kyc_upload_replace: 'পরিবর্তন করতে ট্যাপ করুন',
  kyc_upload_click: 'আপলোড করতে ক্লিক করুন',

  // Security Section
  security_row_title: 'নিরাপত্তা সেটিংস',
  security_login_pw: 'লগইন পাসওয়ার্ড',
  security_login_pw_desc: 'আপনার অ্যাকাউন্টের লগইন পাসওয়ার্ড পরিবর্তন করুন',
  security_change_btn: 'পরিবর্তন করুন',
  security_set_withdrawal_pw_title: 'উইথড্রয়াল পাসওয়ার্ড সেট করুন',
  security_set_withdrawal_pw_desc: 'উইথড্রয়াল অনুমোদনের জন্য একটি আলাদা পিন তৈরি করুন',
  security_set_withdrawal_pw_btn: 'পিন সেট করুন',
  security_change_withdrawal_pw_title: 'উইথড্রয়াল পাসওয়ার্ড পরিবর্তন করুন',
  security_change_withdrawal_pw_desc: 'আপনার বর্তমান উইথড্রয়াল পিন আপডেট করুন',
  security_change_withdrawal_pw_btn: 'পরিবর্তন',
  security_modal_set_withdrawal_title: 'উইথড্রয়াল পাসওয়ার্ড সেট করুন',
  security_modal_set_withdrawal_subtitle: 'প্রতিবার উইথড্র করার সময় এই পিনটির প্রয়োজন হবে।',
  security_modal_change_withdrawal_title: 'উইথড্রয়াল পাসওয়ার্ড পরিবর্তন করুন',
  security_field_current_pin: 'বর্তমান উইথড্রয়াল পিন',
  security_field_new_pin: 'নতুন উইথড্রয়াল পিন',
  security_field_new_pin_6: 'নতুন উইথড্রয়াল পিন (৬ ডিজিট)',
  security_field_confirm_pin: 'পিন নিশ্চিত করুন',
  security_field_confirm_new_pin: 'নতুন পিন নিশ্চিত করুন',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'বর্তমান পাসওয়ার্ড',
  security_pw_new: 'নতুন পাসওয়ার্ড',
  security_pw_confirm: 'নতুন পাসওয়ার্ড নিশ্চিত করুন',
  security_pw_placeholder_current: 'বর্তমান পাসওয়ার্ড লিখুন',
  security_pw_placeholder_new: 'নতুন পাসওয়ার্ড লিখুন',
  security_pw_placeholder_confirm: 'নতুন পাসওয়ার্ডটি আবার লিখুন',
  security_pw_success: 'পাসওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে! লগইনে রিডাইরেক্ট করা হচ্ছে...',
  security_pw_err: 'পাসওয়ার্ড পরিবর্তন করতে ব্যর্থ হয়েছে',
  security_fill_all: 'অনুগ্রহ করে সব ঘর পূরণ করুন।',
  security_match_err: 'পাসওয়ার্ড মেলেনি।',
  security_pin_digit_err: 'পিন শুধুমাত্র সংখ্যা থাকতে হবে।',

  // Support Tickets
  support_page_title: 'সাপোর্ট টিকিট',
  support_page_desc: "সাহায্য প্রয়োজন? আমরা আপনার পাশে আছি।",
  support_btn_create: 'নতুন টিকিট তৈরি করুন',
  support_table_info: 'টিকিট তথ্য',
  support_table_cat: 'বিভাগ',
  support_table_pri: 'অগ্রাধিকার',
  support_table_status: 'স্ট্যাটাস',
  support_table_activity: 'সাম্প্রতিক কার্যকলাপ',
  support_table_action: 'অ্যাকশন',
  support_id_prefix: 'আইডি:',
  support_btn_view: 'দেখুন',
  support_status_open: 'খোলা',
  support_status_closed: 'বন্ধ',
  support_status_pending: 'পেন্ডিং',
  support_priority_default: 'স্বাভাবিক',
  support_no_tickets: 'কোনো টিকিট পাওয়া যায়নি। কোনো প্রশ্ন আছে? আপনার প্রথম টিকিট তৈরি করুন!',
  support_err_load: 'টিকিট লোড করতে ব্যর্থ হয়েছে',
  support_err_fetch: 'টিকিট আনার সময় একটি ত্রুটি ঘটেছে',
  support_details_err_load: 'টিকিটের বিবরণ লোড করতে ব্যর্থ হয়েছে',
  support_details_err_fetch: 'টিকিটের বিবরণ আনার সময় একটি ত্রুটি ঘটেছে',
  support_reply_success: 'উত্তর সফলভাবে পাঠানো হয়েছে',
  support_reply_err: 'উত্তর পাঠাতে ব্যর্থ হয়েছে',
  support_reply_err_occured: 'আপনার উত্তর পাঠানোর সময় একটি ত্রুটি ঘটেছে',
  support_file_size_err: 'ফাইলের আকার ৫ মেগাবাইটের কম হতে হবে',
  support_ticket_id_prefix: 'টিকিট আইডি:',
  support_team: 'সাপোর্ট টিম',
  support_you: 'আপনি',
  support_view_attachment: 'View Attachment',
  support_placeholder_reply: 'আপনার উত্তর এখানে লিখুন...',
  support_attach_file: 'ফাইল সংযুক্ত করুন',
  support_btn_send: 'উত্তর পাঠান',
  support_modal_title: 'নতুন সাপোর্ট টিকিট',
  support_modal_desc: 'উন্নত সহায়তার জন্য আপনার সমস্যার বিবরণ দিন',
  support_subject: 'বিষয়',
  support_subject_placeholder: 'সমস্যার সংক্ষিপ্ত সারসংক্ষেপ',
  support_message: 'বার্তা',
  support_message_placeholder: 'আপনার সমস্যা বিস্তারিত ব্যাখ্যা করুন...',
  support_attachment: 'সংযুক্তি (ঐচ্ছিক)',
  support_attachment_hint: 'Click to upload screenshot or file (Max 5MB)',
  support_btn_creating: 'তৈরি হচ্ছে...',
  support_btn_submit: 'টিকিট জমা দিন',
  support_category_billing: 'বিলিং',
  support_category_technical: 'প্রযুক্তিগত',
  support_category_account: 'অ্যাকাউন্ট',
  support_category_other: 'অন্যান্য',
  support_priority_low: 'নিম্ন',
  support_priority_medium: 'মাঝারি',
  support_priority_high: 'উচ্চ',

  // Settings
  settings_page_title: 'সেটিংস',
  settings_page_desc: 'আপনার নিরাপত্তা, গোপনীয়তা এবং পছন্দগুলো পরিচালনা করুন',
  settings_kyc_label: 'কেওয়াইসি যাচাইকরণ',
  settings_kyc_desc: 'পরিচয় যাচাইকরণ',
  settings_security_label: 'নিরাপত্তা',
  settings_security_desc: 'পাসওয়ার্ড ব্যবস্থাপনা',
  settings_language_label: 'ভাষা',
  settings_language_desc: 'আঞ্চলিক পছন্দ',

  // How It Works Steps
  step_1_title: 'অ্যাকাউন্ট তৈরি করুন',
  step_1_desc: '২ মিনিটেরও কম সময়ে তৈরি করুন।',
  step_1_detail_1: 'মৌলিক তথ্য প্রদান করুন',
  step_1_detail_2: 'ইমেল যাচাই করুন',
  step_1_detail_3: 'অ্যাকাউন্ট নিরাপদ করুন',
  step_1_detail_4: 'তাত্ক্ষণিক ড্যাশবোর্ড অ্যাক্সেস',
  step_2_title: 'টাস্ক সন্ধান করুন',
  step_2_desc: 'উপলব্ধ প্রমোশন টাস্ক থেকে বেছে নিন।',
  step_2_detail_1: 'প্ল্যাটফর্ম অনুযায়ী ফিল্টার করুন',
  step_2_detail_2: 'কমিশনের হার দেখুন',
  step_2_detail_3: 'একাধিক টাস্ক গ্রহণ করুন',
  step_2_detail_4: 'রিয়েল-টাইম টাস্ক আপডেট',
  step_3_title: 'টাস্ক সম্পন্ন করুন',
  step_3_desc: 'নির্দেশনা অনুযায়ী প্রমোশন সম্পন্ন করুন।',
  step_3_detail_1: 'সহজ অনুসরণযোগ্য পদক্ষেপ',
  step_3_detail_2: 'দ্রুত প্রমোশন জমা',
  step_3_detail_3: 'স্বয়ংক্রিয় যাচাইকরণ',
  step_3_detail_4: 'মোবাইল-বান্ধব ইন্টারফেস',
  step_4_title: 'উপার্জন ও উত্তোলন',
  step_4_desc: 'প্রতিটি সম্পন্ন টাস্কের জন্য পেমেন্ট পান।',
  step_4_detail_1: 'রিয়েল-টাইম উপার্জন ট্র্যাকিং',
  step_4_detail_2: 'কম সর্বনিম্ন উত্তোলন সীমা',
  step_4_detail_3: 'একাধিক পেমেন্ট পদ্ধতি',
  step_4_detail_4: '২৪/৭ উত্তোলন সাপোর্ট',

  // Redesigned Footer
  footer_stay_loop_title: 'খবর রাখুন',
  footer_stay_loop_desc: 'সর্বশেষ আপডেট, টিপস এবং এক্সক্লুসিভ অফার সরাসরি আপনার ইনবক্সে পান।',
  footer_subscribe: 'সাবস্ক্রাইব করুন',
  footer_subscribe_placeholder: 'আপনার ইমেল ঠিকানা লিখুন',
  footer_trusted_secure: 'নির্ভরযোগ্য এবং নিরাপদ:',
  footer_ssl_secured: 'SSL সুরক্ষিত',
  footer_ssl_secured_desc: '২৫৬-বিট SSL',
  footer_aes_encryption: 'AES-২৫৬ এনক্রিপশন',
  footer_aes_encryption_desc: 'ব্যাঙ্ক-গ্রেড',
  footer_kyc_compliant: 'KYC কমপ্লায়েন্ট',
  footer_kyc_compliant_desc: 'ভেরিফাইড',
  footer_gdpr_compliant: 'GDPR কমপ্লায়েন্ট',
  footer_gdpr_compliant_desc: 'ডেটা সুরক্ষিত',
  footer_iso_certified: 'ISO ২৭০০১',
  footer_iso_certified_desc: 'সার্টিফাইড',
  footer_platform: 'প্ল্যাটফর্ম',
  footer_support: 'সাপোর্ট',
  footer_legal: 'লিগ্যাল',
  footer_help_center: 'সহায়তা কেন্দ্র',
  footer_contact_us: 'যোগাযোগ করুন',
  footer_payments_label: 'পেমেন্ট:',
  home_live_activity_title: 'লাইভ প্ল্যাটফর্ম ক্রিয়াকলাপ',
  home_recent_activity_title: 'সাম্প্রতিক ক্রিয়াকলাপ',
  home_total_commissions_paid: 'মোট পরিশোধিত কমিশন',
  home_active_users_online: 'অনলাইন সক্রিয় ব্যবহারকারী',
  home_tasks_completed_today: 'আজ সম্পন্ন করা কাজ',
  account_security_tips_title: 'নিরাপত্তা সুপারিশ',
  account_security_tips_desc: 'এই সহজ সর্বোত্তম অনুশীলনগুলি অনুসরণ করে আপনার অ্যাকাউন্টের সুরক্ষা উন্নত করুন।',
  tip_password_title: 'শক্তিশালী পাসওয়ার্ড',
  tip_password_desc: 'আপনার অ্যাকাউন্ট নিরাপদ রাখতে অক্ষর, সংখ্যা এবং চিহ্নের সংমিশ্রণ ব্যবহার করুন।',
  tip_two_factor_title: 'পরিচয় যাচাইকরণ',
  tip_two_factor_desc: 'গুরুত্বপূর্ণ নিরাপত্তা বিজ্ঞপ্তি পেতে আপনার যোগাযোগের তথ্য আপডেট রাখুন।',
  tip_logout_title: 'নিয়মিত লগ আউট করুন',
  tip_logout_desc: 'সর্বজনীন বা ভাগ করা কম্পিউটার ব্যবহারের সময় সর্বদা আপনার অ্যাকাউন্ট থেকে লগ আউট করুন।',
  tip_sharing_title: 'অ্যাক্সেস শেয়ার করবেন না',
  tip_sharing_desc: 'আমাদের সাপোর্ট টিম কখনই আপনার পাসওয়ার্ড চাইবে না। কারো সাথে আপনার শংসাপত্র শেয়ার করবেন না।',

  // অর্ডার অনুরোধ
  order_requests_title: 'অর্ডার অনুরোধ',
  order_requests_desc: 'একটি নতুন টাস্ক বা কাস্টম অর্ডারের জন্য অনুরোধ জমা দিন। অ্যাডমিনিস্ট্রেটর আপনার অনুরোধের ভিত্তিতে টাস্ক পর্যালোচনা এবং বরাদ্দ করবেন।',
  order_requests_new_btn: 'নতুন অর্ডারের অনুরোধ',
  order_requests_table_id: 'অনুরোধ আইডি',
  order_requests_table_data: 'অনুরোধের বিস্তারিত',
  order_requests_table_status: 'স্ট্যাটাস',
  order_requests_table_date: 'জমা দেওয়ার তারিখ',
  order_requests_table_actions: 'অ্যাকশন',
  order_requests_cancel: 'বাতিল করুন',
  order_requests_cancel_confirm: 'আপনি কি নিশ্চিত যে আপনি এই অর্ডারের অনুরোধটি বাতিল করতে চান?',
  order_requests_cancel_success: 'অর্ডারের অনুরোধ সফলভাবে বাতিল করা হয়েছে।',
  order_requests_create_success: 'অর্ডারের অনুরোধ সফলভাবে জমা দেওয়া হয়েছে।',
  order_requests_modal_title: 'নতুন অর্ডারের অনুরোধ জমা দিন',
  order_requests_modal_desc: 'আপনি যে অর্ডারের জন্য অনুরোধ করতে চান সে সম্পর্কে বিস্তারিত তথ্য দিন।',
  order_requests_field_data: 'অর্ডার অনুরোধের ডাটা',
  order_requests_field_placeholder: 'উদা: আমি প্রিমিয়াম প্যাকেজের জন্য একটি কাস্টম অর্ডারের অনুরোধ করতে চাই।',
  order_requests_btn_submit: 'অনুরোধ জমা দিন',
  order_requests_btn_submitting: 'জমা হচ্ছে...',
  order_requests_empty: 'কোনো অর্ডারের অনুরোধ পাওয়া যায়নি।',
  order_requests_status_pending: 'পেন্ডিং',
  order_requests_status_approved: 'অনুমোদিত',
  order_requests_status_rejected: 'প্রত্যাখ্যাত',
  order_requests_status_cancelled: 'বাতিল',
  order_requests_terms_title: 'বাইন্ডিং অর্ডার টার্মস',
  order_requests_term_1: 'অনুমোদনের ২৪-৪৮ ঘণ্টার মধ্যে নতুন অর্ডার বরাদ্দ করা হবে।',
  order_requests_term_2: 'একবার রিলিজ হয়ে গেলে, অর্ডার বাতিল, বিরতি বা পরিবর্তন করা যাবে না।',
  order_requests_term_3: 'উত্তোলনের আগে সমস্ত বরাদ্দকৃত অর্ডার অবশ্যই সম্পন্ন করতে হবে।',
  order_requests_term_4: 'অর্ডার সম্পন্ন করতে ব্যর্থ হলে আপনার অ্যাকাউন্টের স্থিতি প্রভাবিত হতে পারে।',
  order_requests_term_5: 'এই অনুরোধটি চূড়ান্ত এবং জমা দেওয়ার পরে পরিবর্তন করা সম্ভব নয়।',
  order_requests_policy_title: 'কোনো বাতিলকরণ নীতি নেই',
  order_requests_policy_desc: 'এই অনুরোধটি জমা দেওয়ার মাধ্যমে আপনি স্বীকার করছেন যে নতুন অর্ডার ব্যাচটি অপরিবর্তনীয়। একবার আমাদের সিস্টেম দ্বারা নিশ্চিত হয়ে গেলে, কোনো পরিস্থিতিতে কোনো বাতিলকরণ, পরিবর্তন বা রিফান্ড অনুমোদিত হবে না।',
  order_requests_accept_terms: 'আমি উপরের শর্তাবলী পড়েছি এবং পুরোপুরি বুঝেছি। আমি স্বীকার করছি যে একবার জমা দেওয়ার পরে, এই অর্ডারের অনুরোধটি বাতিল বা পরিবর্তন করা যাবে না এবং আমি সমস্ত বরাদ্দকৃত অর্ডার সম্পন্ন করতে সম্মত।',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'উইথড্রয়াল পলিসি',
  orders_unlock_req: 'আনলক করার প্রয়োজনীয়তা',
  orders_unlock_desc: 'উইথড্রয়াল স্থায়ীভাবে আনলক করতে আপনার {{count}}টি অর্ডারের প্রথম ব্যাচ সম্পন্ন করুন। এই এককালীন প্রয়োজনীয়তা প্ল্যাটফর্মের সততা নিশ্চিত করে এবং অপব্যবহার রোধ করে।',
  orders_daily_limits: 'দৈনিক অর্ডার লিমিট',
  orders_daily_limit_1: 'প্রতি ব্যাচে {{count}}টি অর্ডার — পরবর্তী ব্যাচের অনুরোধ করার আগে সব সম্পন্ন করতে হবে',
  orders_daily_limit_2: 'প্রতিদিন সর্বোচ্চ {{count}}টি ব্যাচ ({{total}}টি অর্ডার/দিন)',
  orders_comm_rates: 'কমিশন রেট',
  orders_comm_rates_desc: 'রেট প্ল্যাটফর্ম এবং আপনার বর্তমান ওয়ালেট ব্যালেন্সের উপর ভিত্তি করে নির্ধারিত হয়:',
  orders_payout_timeline: 'পেআউট টাইমলাইন',
  orders_payout_desc: 'উইথড্রয়াল ২৪-৪৮ ঘন্টার মধ্যে প্রসেস করা হয়। ব্যাংক ট্রান্সফারের ক্ষেত্রে ৩-৫ কার্যদিবস সময় লাগতে পারে। ক্রিপ্টো উইথড্রয়াল তাৎক্ষণিক।',
  orders_processing_fee: 'লেনদেনের খরচ মেটাতে সমস্ত উইথড্রয়ালের উপর {{fee}}% প্রসেসিং ফি প্রযোজ্য।',
  orders_tips_title: 'সফল হওয়ার পরামর্শ',
  orders_tips_1: 'গতিশীলতা বজায় রাখতে এবং আয় বাড়াতে প্রতিদিন অর্ডার সম্পন্ন করুন',
  orders_tips_2: 'সঠিক সমাপ্তি নিশ্চিত করতে প্রসেসিং চলাকালীন পেজে থাকুন',
  orders_tips_3: 'কমিশনের বৃদ্ধি ট্র্যাক করতে নিয়মিত আপনার ওয়ালেট চেক করুন',
  orders_tips_4: 'তাদের অর্ডার থেকে বোনাস কমিশন পেতে বন্ধুদের রেফার করুন',
  orders_tips_5: 'কোনো সমস্যার সম্মুখীন হলে তাৎক্ষণিক সাপোর্টের সাথে যোগাযোগ করুন',
  orders_batch_approx: '{{count}}টি অর্ডার/ব্যাচ × গড় ${{avg}} = প্রতি ব্যাচে প্রায় ${{total}}',
};
